/**
 * Mobile Menu
 *
 * Hamburger toggle + accordion sub-menus for mobile navigation.
 * Works alongside desktop dropdown-menu.js (which handles desktop hover).
 */

function initMobileMenu() {
	const toggle = document.querySelector( '.js-mobile-menu-toggle' );
	const mobileNav = document.querySelector( '.js-mobile-nav' );

	if ( ! toggle || ! mobileNav ) {
		return;
	}

	// Toggle open/close
	toggle.addEventListener( 'click', () => {
		const isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';

		if ( isOpen ) {
			close();
		} else {
			open();
		}
	} );

	// Close button inside mobile nav overlay
	const closeBtn = mobileNav.querySelector( '.js-mobile-nav-close' );
	if ( closeBtn ) {
		closeBtn.addEventListener( 'click', () => close() );
	}

	function open() {
		toggle.setAttribute( 'aria-expanded', 'true' );
		mobileNav.setAttribute( 'aria-hidden', 'false' );
		document.body.style.overflow = 'hidden';
	}

	function close() {
		toggle.setAttribute( 'aria-expanded', 'false' );
		mobileNav.setAttribute( 'aria-hidden', 'true' );
		document.body.style.overflow = '';

		// Collapse all sub-menus
		for ( const item of mobileNav.querySelectorAll( '[aria-expanded="true"]' ) ) {
			item.setAttribute( 'aria-expanded', 'false' );
		}
		for ( const wrapper of mobileNav.querySelectorAll( '.mega-menu__wrapper, .sub-menu' ) ) {
			wrapper.setAttribute( 'aria-hidden', 'true' );
		}
		for ( const caret of mobileNav.querySelectorAll( '.menu-item__caret[aria-expanded="true"]' ) ) {
			caret.setAttribute( 'aria-expanded', 'false' );
		}
	}

	// Escape key closes mobile menu
	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' && toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
			close();
		}
	} );

	// Accordion: toggle sub-menus on caret click (event delegation)
	mobileNav.addEventListener( 'click', ( e ) => {
		const caret = e.target.closest( '.js-menu-caret' );
		if ( ! caret ) return;

		e.stopPropagation();
		e.preventDefault();

		const li = caret.closest( '.menu-item' );
		if ( ! li ) return;

		const isExpanded = li.getAttribute( 'aria-expanded' ) === 'true';
		const sub = li.querySelector( ':scope > .mega-menu__wrapper, :scope > .sub-menu' );

		if ( isExpanded ) {
			li.setAttribute( 'aria-expanded', 'false' );
			if ( sub ) sub.setAttribute( 'aria-hidden', 'true' );
			caret.setAttribute( 'aria-expanded', 'false' );
		} else {
			li.setAttribute( 'aria-expanded', 'true' );
			if ( sub ) sub.setAttribute( 'aria-hidden', 'false' );
			caret.setAttribute( 'aria-expanded', 'true' );
		}
	} );

	// Empty link (#) clicks toggle sub-menu in mobile
	for ( const link of mobileNav.querySelectorAll( 'a[href="#"]' ) ) {
		link.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			const li = link.closest( '.menu-item' );
			if ( ! li ) return;

			const caret = li.querySelector( ':scope > .menu-item__link > .menu-item__caret' );
			if ( caret ) {
				caret.click();
			}
		} );
	}

	// Close mobile nav on window resize to desktop
	let resizeTimer;
	window.addEventListener( 'resize', () => {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( () => {
			if ( window.innerWidth > 1199 && toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
				close();
			}
		}, 100 );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initMobileMenu );
} else {
	initMobileMenu();
}
